import React, { useEffect, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import i18n from '../i18n';
import Header from '../components/Header';
import Footer from '../components/Footer';

export default function NotFound() {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();

  const lang = useMemo(() => {
    const pathLang = location.pathname.split('/')[1];
    return pathLang === 'ar' ? 'ar' : 'en';
  }, [location.pathname]);

  useEffect(() => {
    document.body.style.direction = lang === 'ar' ? 'rtl' : 'ltr';
    i18n.changeLanguage(lang);
    localStorage.setItem('lang', lang);
  }, [lang]);

  return (
    <div className={lang === 'ar' ? 'rtl mx-auto' : 'ltr mx-auto'}>
      <div className="w-full mx-auto min-h-screen flex flex-col" style={{ maxWidth: '1440px' }}>
        <Header />
        <main className="flex-1 flex items-center justify-center px-5 pt-32 pb-16">
          <section className="text-center max-w-2xl mx-auto">
            <p className="text-blue font-bold text-2xl mb-3">{t('404')}</p>
            <h1 className="text-darkblue sm:text-4xl text-3xl font-bold mb-4">
              {t('Page not found')}
            </h1>
            <p className="text-gray sm:text-lg text-base leading-7 mb-8">
              {t('The page you are looking for does not exist or may have been moved.')}
            </p>
            <button
              className="bg-blue-600 text-white rounded-lg focus:outline-none px-8 h-12 font-semibold"
              onClick={() => navigate(`/${lang}`)}
            >
              {t('Back to home')}
            </button>
          </section>
        </main>
      </div>
      <Footer />
    </div>
  );
}
